import PropTypes from 'prop-types';

import { FormReader } from '@/components/forms';
import { downloadFile } from '@/utils/downloadFile';
import { multipleFileDownload } from '@/utils/downloadFile/multipleFileDownload';

export const FormBody = ({ linkCreatedByAccount, link, workflowContext }) => {
  const { action, data } = link;
  const { description } = action || {};

  const schema = action?.form?.schema || {
    type: 'object',
    description: action?.description
  };
  const uiSchema = action?.form?.uiSchema || {};
  const { name } = linkCreatedByAccount?.entity || link.group;

  // Schemas with no `properties` that only declare `additionalProperties:
  // true` (typical of bot/ingestion actions dumping a raw claim object)
  // give the form renderer nothing to infer array `items` from, so it
  // shows an "Unsupported field schema" warning per array field instead
  // of the data. Same fallback as the no-action case: raw JSON is more
  // useful than a form full of warnings.
  const isSchemaless =
    schema.type === 'object' &&
    !schema.properties &&
    schema.additionalProperties === true;

  if (!action || isSchemaless) {
    // Fallback on displaying the JSON data if
    // action is not set for some reason.
    return <pre>{JSON.stringify(data, null, 2)}</pre>;
  }

  const formData = link?.answer
    ? { comment: link.answer, files: link.files }
    : data;

  return (
    <FormReader
      description={description}
      downloadAllFiles={multipleFileDownload}
      downloadFile={downloadFile}
      formData={formData}
      schema={schema}
      uiSchema={uiSchema}
      when={link.createdAt}
      who={name}
      workflowContext={workflowContext}
    />
  );
};

FormBody.propTypes = {
  action: PropTypes.object,
  data: PropTypes.object,
  linkCreatedByAccount: PropTypes.object,
  link: PropTypes.object.isRequired,
  workflowContext: PropTypes.object.isRequired
};
